
export default {
  formActions: {
    addPlaceInput: 'Add place input',
    clearRoute: 'Clear route',
    reverseRoute: 'Reverse route',
    roundTrip: 'Round trip',
    toggleRoundTrip: 'Toggle round trip',
    showDangerousAreas: 'Dangerous Areas',
    cycle: 'Cycle Lanes in Lisbon',
    button : 'Orientation Permission',
    downloadButton : 'Route Download',
    hostport: 'Hotspot Map Points'
  }
}
